<template>
  <v-card v-if="!loading">
    <v-row>
      <v-col cols="8">
        <v-card-subtitle>Данные пользователя:</v-card-subtitle>
        <v-card-text>
          <v-list>
            <v-list-item v-if="data.firstName">
              <v-list-item-content>
                {{ 'Фамилия: ' + data.firstName }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.lastName">
              <v-list-item-content>
                {{ 'Имя: ' + data.lastName }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.middleName">
              <v-list-item-content>
                {{ 'Отчество: ' + data.middleName }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.login">
              <v-list-item-content>
                {{ 'Логин: ' + data.login }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.email">
              <v-list-item-content>
                {{ 'Email: ' + data.email }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.phone">
              <v-list-item-content>
                {{ 'Телефон: ' + convertToPhone(data.phone) }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.birthday">
              <v-list-item-content>
                {{ 'Дата рождения: ' + data.birthday }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="data.gender">
              <v-list-item-content>
                {{ 'Пол: ' + data.gender }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-col>
      <v-col cols="4">
        <v-img
          v-if="data.avatarUrl"
          :src="data.avatarUrl"
          :max-width="100"
          :max-height="100"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Любимые</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row v-if="data.favoriteAudioguides">
                <v-col cols="12">
                  <span>{{ 'Аудиогиды: ' + data.favoriteAudioguides.length }}</span>
                </v-col>
              </v-row>
              <v-row v-if="data.favoriteEvents">
                <v-col cols="12">
                  <span> {{ 'События: ' + data.favoriteEvents.length }}</span>
                </v-col>
              </v-row>
              <v-row v-if="data.favoritePlaces">
                <v-col cols="12">
                  <span>{{ 'Места: ' + data.favoritePlaces.length }}</span>
                </v-col>
              </v-row>
              <v-row v-if="data.favoriteRoutes">
                <v-col cols="12">
                  <span>{{ 'Маршруты: ' + data.favoriteRoutes.length }}</span>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { convertToPhone } from '@/configs/numbers'
export default {
  name: 'UserAccount',
  props: {
    loading: {
      type: Boolean,
      default: null
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    convertToPhone
  }
}
</script>
